module.exports = __webpack_public_path__ + "img/文留镇-c.78655bb3.png";